import { BulkUpdateUsersRequest } from '@crew/apis/user/models/bulkUpdateUsers/request'
import { TenantSettingMember } from '@crew/apis/tenantSetting/models/getTenantSettingMembers/response'
import {
  useBulkUpdateUsersMutation,
  useVerifyBulkUpdateUsersMutation,
} from '@crew/apis/user/userApis'
import { NotifyEventType } from 'enums/app'
import {
  ObjectEventMessage,
  notifyTenantSettingUserEventMessageEvent,
} from 'features/app/states/appSlice'
import { useCallback } from 'react'
import { useAppDispatch } from 'states/hooks'

export const useTenantUserBulkUpdateDialog = () => {
  const dispatch = useAppDispatch()

  const [verifyBulkUpdateUsersMutation] = useVerifyBulkUpdateUsersMutation()
  const [bulkUpdateUsersMutation, { isLoading: isLoadingBulkUpdateUsers }] =
    useBulkUpdateUsersMutation()

  // 更新内容の検証
  const verifyBulkUpdateUsers = useCallback(
    async (file: File) => {
      const result = await verifyBulkUpdateUsersMutation({
        file: file,
      }).unwrap()

      return result
    },
    [verifyBulkUpdateUsersMutation]
  )

  // ユーザーを一括更新
  const bulkUpdateUsers = useCallback(
    async (data: BulkUpdateUsersRequest) => {
      // 一括更新API実行
      await bulkUpdateUsersMutation(data).unwrap()

      // ユーザーリストの更新イベントをトリガー
      const objectEventMessage: ObjectEventMessage<TenantSettingMember> = {
        eventType: NotifyEventType.Updated,
        id: '',
        object: undefined,
      }
      dispatch(notifyTenantSettingUserEventMessageEvent(objectEventMessage))
    },
    [bulkUpdateUsersMutation, dispatch]
  )

  return {
    verifyBulkUpdateUsers,
    bulkUpdateUsers,
    isLoadingBulkUpdateUsers,
  }
}
